/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';

import * as actions from '../action';
import Applications from './Applications';

function ApplicationContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['VIEW OHP NEW TRANSACTIONS']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/occupational-and-health/application/new"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        'occupational-and-health/application/new'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    New
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW OHP EDUC TRANSACTIONS']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/occupational-and-health/application/educational-institution"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        'occupational-and-health/application/educational-institution'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Educational Institution
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['VIEW OHP NEW TRANSACTIONS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/new`} />}
            />
          )}
          {Acl(permissions, ['VIEW OHP EDUC TRANSACTIONS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => (
                <Redirect to={`${match.path}/educational-institution`} />
              )}
            />
          )}
          {(Acl(permissions, ['VIEW OHP NEW TRANSACTIONS']) ||
            Acl(permissions, ['VIEW OHP EDUC TRANSACTIONS'])) && (
            <Route
              path={`${match.path}/:transaction_type`}
              component={Applications}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

ApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainer);
